import { render, staticRenderFns } from "./StepperStep.vue?vue&type=template&id=4b5ef90d&scoped=true"
import script from "./StepperStep.vue?vue&type=script&lang=ts"
export * from "./StepperStep.vue?vue&type=script&lang=ts"
import style0 from "./StepperStep.vue?vue&type=style&index=0&id=4b5ef90d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ef90d",
  null
  
)

export default component.exports